<template>
  <div>
    <v-container grid-md>
      <v-layout style="display: flex; flex-wrap: wrap">
        <v-flex d-flex class="login-box">
          <main v-if="loggedIn === false">
            <PageIntro
              v-if="appLogin === false"
              :heading="'Verified your account? Now you can log in'"
              :body="'<p>If you have verified your account, you can log in using the form below.</p>'"
            />

            <Login />
          </main>
        </v-flex>
      </v-layout>
    </v-container>
    <FooterShout v-if="appLogin === false" :type="'register'" />
  </div>
</template>

<script>
import Login from "@/components/Login";
import PageIntro from "@/components/PageIntro";
import FooterShout from "@/components/FooterShout";

export default {
  components: {
    Login,
    PageIntro,
    FooterShout,
  },
  data() {
    return {
      from: null,
      appLogin: false,
      loggedIn: true, //assume they are logged in
    };
  },
  mounted() {
    // if they are coming from the app specific login URL adapt the page accordingly
    if (this.$router.currentRoute.name === "app-login") {
      this.appLogin = true;
    }
    if (this.$getAuthenticatedUser() != null) {
      this.loggedIn = true;
    } else {
      this.loggedIn = false;
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.from = from;

      // TODO: Make sure we handle people referred from password reset with a message on sign in page
    });
  },
};
</script>
<style lang="scss" scoped>
.login-box {
  width: 100%;
  @media screen and (min-width: 700px) {
    width: 50%;
  }
}

.home-box {
  width: 100%;
  @media screen and (min-width: 700px) {
    width: 50%;
  }
}
</style>
